import React from "react";

const Block = (props) => {

const handleClick = e => {
  if (props.blockp2) {
  const bg = document.getElementById(props.blockh2);
  e.preventDefault();
  bg.classList.toggle("hidden");
  }
}

return(
<div className={['flex', 'flex-col', 'h-full', 'w-full', 'border-black',
    'md:flex-row', 'md:h-auto',
    props.border ? 'border-t-0' : 'border-t-4',
    props.margin ? 'mb-0' : 'msb'].join(" ")}>

  <div className={['pt-1', 'pb-2', 'pr-2', 'txtbody', 'leading-loose', 'font-bold',
  'md:w-2/5', 'md:leading-normal',
  props.margin ? 'mb-0' : 'msb'].join(" ")}>
  {props.blockh2}
  </div>

  <div onClick={handleClick} className={['txtbody', 'leading-normal', 'font-normal', 'tap',
 'md:w-3/5', 'md:pt-1', 'md:pr-2',
  props.margin ? 'mb-0' : 'msb'].join(" ")}>
  {props.blockp} {props.blockp2 ? '↪︎' : null}
  <br/>{props.blockp2}
  </div>

</div>
);
};

export default Block;


// WEBPACK FOOTER //
// ./src/components/TextPage/block.js